import * as React from "react";
import { ContentProps } from "components/flexComponents/Content/typings";
import {
  UitkLayoutGrid,
  UitkLayoutGridItem,
  UitkLayoutGridColumnRow,
  UitkLayoutGridSpan,
} from "uitk-react-layout-grid";
import { decorateEditorialHtml } from "../../../ContentUtilities";
import { UitkText } from "uitk-react-text";

export const IconSectionEditorial = (props: ContentProps) => {
  const imageClassNames = "uitk-type-center all-t-padding-six xl-t-padding-twelve";
  const titleClassNames = "all-t-padding-four";
  const descriptionClassNames = "all-t-padding-one";

  const flexComponent = props.flexComponent;
  const model = flexComponent && flexComponent.model;
  const items = (model && model.items && model.items.filter((item) => item)) || [];

  if (!model || items.length !== 10) {
    return null;
  }

  const [
    iconSectionTitle,
    moreRewardsIcon,
    moreRewardsTitle,
    moreRewardsDescription,
    ultimateFlexibilityIcon,
    ultimateFlexibilityTitle,
    ultimateFlexibilityDescription,
    lessHassleIcon,
    lessHassleTitle,
    lessHassleDescription,
  ] = items.map((item) => decorateEditorialHtml(item.text));

  const IconColSpan = {
    extra_large: 4 as UitkLayoutGridSpan,
    large: 4 as UitkLayoutGridSpan,
    medium: 1 as UitkLayoutGridSpan,
    small: 1 as UitkLayoutGridSpan,
  };

  const gridColumns = {
    extra_large: 12 as UitkLayoutGridColumnRow,
    large: 12 as UitkLayoutGridColumnRow,
    medium: 1 as UitkLayoutGridColumnRow,
    small: 1 as UitkLayoutGridColumnRow,
  };

  return (
    <div className="all-y-padding-twelve icon-section">
      <UitkText align="center" size={600} weight="bold" spacing="four">
        <div dangerouslySetInnerHTML={iconSectionTitle} />
      </UitkText>

      <UitkText spacing="six" />

      <UitkLayoutGrid columns={gridColumns}>
        <UitkLayoutGridItem colSpan={IconColSpan}>
          <UitkLayoutGrid justifyItems="center">
            <UitkLayoutGridItem>
              <div>
                <div dangerouslySetInnerHTML={moreRewardsIcon} className={imageClassNames} />
                <UitkText align="center" size={500} weight="bold">
                  <div dangerouslySetInnerHTML={moreRewardsTitle} className={titleClassNames} />
                </UitkText>
                <UitkText align="center" size={300}>
                  <div dangerouslySetInnerHTML={moreRewardsDescription} className={descriptionClassNames} />
                </UitkText>
              </div>
            </UitkLayoutGridItem>
          </UitkLayoutGrid>
        </UitkLayoutGridItem>

        <UitkLayoutGridItem colSpan={IconColSpan}>
          <UitkLayoutGrid justifyItems="center">
            <UitkLayoutGridItem>
              <div>
                <div dangerouslySetInnerHTML={ultimateFlexibilityIcon} className={imageClassNames} />

                <UitkText align="center" size={500} weight="bold">
                  <div dangerouslySetInnerHTML={ultimateFlexibilityTitle} className={titleClassNames} />
                </UitkText>

                <UitkText align="center" size={300}>
                  <div dangerouslySetInnerHTML={ultimateFlexibilityDescription} className={descriptionClassNames} />
                </UitkText>
              </div>
            </UitkLayoutGridItem>
          </UitkLayoutGrid>
        </UitkLayoutGridItem>

        <UitkLayoutGridItem colSpan={IconColSpan}>
          <UitkLayoutGrid justifyItems="center">
            <UitkLayoutGridItem>
              <div>
                <div dangerouslySetInnerHTML={lessHassleIcon} className={imageClassNames} />

                <UitkText align="center" size={500} weight="bold">
                  <div dangerouslySetInnerHTML={lessHassleTitle} className={titleClassNames} />
                </UitkText>

                <UitkText align="center" size={300}>
                  <div dangerouslySetInnerHTML={lessHassleDescription} className={descriptionClassNames} />
                </UitkText>
              </div>
            </UitkLayoutGridItem>
          </UitkLayoutGrid>
        </UitkLayoutGridItem>
      </UitkLayoutGrid>
    </div>
  );
};

export default IconSectionEditorial;
